import React, { useEffect, useState } from "react";
import { Button, Menu } from "antd";
import { styled } from "styled-components";
import { Header } from "antd/es/layout/layout";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

import useResponsive from "../../hooks/useResponsive";
import { MENU_ITEMS } from "./Menus";

const NavBar = () => {
  const [current, setCurrent] = useState();
  const [collapsed, setCollapsed] = useState(false);
  const { isTablet, isMobile } = useResponsive();
  const { SubMenu } = Menu;

  const renderMenuItem = (item) => {
    if (item.children) {
      return (
        <SubMenu key={item.key} title={item.label} icon={item.icon}>
          {item.children.map((child) => (
            <Menu.Item
              style={{
                fontFamily: "Sarabun",
              }}
              key={child.key}
              icon={item.icon}
              disabled={child.disabled}
            >
              {child.label}
            </Menu.Item>
          ))}
        </SubMenu>
      );
    }

    return (
      <Menu.Item
        style={{
          fontFamily: "Sarabun",
        }}
        key={item.key}
        icon={item.icon}
        disabled={item.disabled}
      >
        {item.label}
      </Menu.Item>
    );
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const currentPath = window.location.pathname;
  const firstPath = currentPath.split("/")[1];
  const onClick = (e) => {
    setCurrent(e.key);
    window.location.href = e.key;
  };

  useEffect(() => {
    setCurrent(firstPath || "/");
  }, [firstPath]);

  return (
    <>
      <Header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1,
          width: "100%",
          backgroundColor: "white",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          padding: 0,
          display: collapsed ? "block" : "flex",
          alignItems: "center",
          height: collapsed && "100vh",
          paddingTop: collapsed && "7px",
        }}
      >
        <Container>
          <Logo src="/su-logo.png" alt="Scripture Union - Thailand" />
          <MenuContainer>
            {isTablet || isMobile ? (
              <Button onClick={toggleCollapsed}>
                {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              </Button>
            ) : (
              <Menu
                onClick={onClick}
                selectedKeys={[current]}
                mode="horizontal"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {MENU_ITEMS.map((item) => renderMenuItem(item))}
              </Menu>
            )}
          </MenuContainer>
        </Container>
        {collapsed && (isTablet || isMobile) && (
          <Menu
            onClick={onClick}
            selectedKeys={[current]}
            mode="inline"
            items={MENU_ITEMS}
            style={{
              fontFamily: "Sarabun",
              marginTop: "30px",
            }}
          />
        )}
      </Header>
    </>
  );
};

const Container = styled.div`
  max-width: 1400px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 767px) {
    justify-content: center;
  }
`;

const Logo = styled.img`
  max-height: 50px;
`;

const MenuContainer = styled.div`
  width: 80%;
  display: flex;
  justify-content: flex-end;
`;

export default NavBar;
